import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICorrelationCurve } from '@app/api/interfaces/chart-data/correlation-curve';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export interface IFpCorrelationGraphState {
  currentTab: FpCorrelationTabs.CorrelationGraph;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
  data: ICorrelationCurve[] | null;
  loading: boolean;
  isChartFullscreenActive: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpCorrelationGraphState: IFpCorrelationGraphState = {
  currentTab: FpCorrelationTabs.CorrelationGraph,
  date: null,
  popupMainData: null,
  data: null,
  loading: false,
  isChartFullscreenActive: false,
  error: null,
};
